import { z } from 'zod'

import { AcademySchema } from '~/@entities/Academy'
import { StudentSchema } from '~/@entities/Student'
import { sliceSchema } from '~/schema/slice'

/***************** 발송 기록 *****************/
export const SMS_SENDING_STATUS = ['REQUESTED', 'SUCCESS', 'FAIL'] as const
export const SMS_TARGET = ['STUDENT', 'PARENTS', 'TEACHER'] as const
// 서버가 본문 길이(euc-kr 90바이트 초과면 LMS)로 정한다
export const SMS_SENDING_TYPE = ['SMS', 'LMS'] as const

export const SmsSendingStatusSchema = z.enum(SMS_SENDING_STATUS)
export type SmsSendingStatus = z.infer<typeof SmsSendingStatusSchema>

export const SmsTargetSchema = z.enum(SMS_TARGET)
export type SmsTarget = z.infer<typeof SmsTargetSchema>

export const SmsSendingTypeSchema = z.enum(SMS_SENDING_TYPE)
export type SmsSendingType = z.infer<typeof SmsSendingTypeSchema>

export const SmsSchema = z.object({
  status: SmsSendingStatusSchema,
  target: SmsTargetSchema,
  type: SmsSendingTypeSchema,
  studentName: StudentSchema.shape.name,
  /** 발신 번호 */
  sender: z.string(),
  /** 수신 번호 */
  receiver: z.string(),
  message: z.string(),
  /** 요금(원). 성공한 문자만 값이 있고 나머지는 0 이다 */
  fee: z.number(),
  /** 발송 요청 시각 */
  createDatetime: z.iso.datetime({ local: true }),
})
export type Sms = z.infer<typeof SmsSchema>

export const SmsSummarySchema = z.object({
  success: z.number(),
  fail: z.number(),
  requested: z.number(),
})
export type SmsSummary = z.infer<typeof SmsSummarySchema>

export const SmsHistorySchema = z.object({
  summary: SmsSummarySchema,
  page: sliceSchema(SmsSchema),
})
export type SmsHistory = z.infer<typeof SmsHistorySchema>

/***************** 템플릿 *****************/
// BASIC 은 서버가 학원마다 만들어 두는 기본 템플릿이고, CUSTOM 은 선생님이 만든 템플릿이다.
export const SMS_TEMPLATE_TYPE = ['BASIC', 'CUSTOM'] as const

// 템플릿의 용도. 서버가 템플릿 제목(등원 안내·하원 안내 등)으로 정하므로 제목이 용도 이름과 다르면 null 이다.
export const SMS_TEMPLATE_SENDING_TYPE = [
  'ENTER',
  'EXIT',
  'TUITION_REQUEST',
  'TUITION_RESPONSE',
  'REPORT',
  'REPORT_SHARE',
  'APP_DOWNLOAD',
  'STUDENT_ID',
  'PARENT_ID',
] as const

export const SmsTemplateTypeSchema = z.enum(SMS_TEMPLATE_TYPE)
export type SmsTemplateType = z.infer<typeof SmsTemplateTypeSchema>

export const SmsTemplateSendingTypeSchema = z.enum(SMS_TEMPLATE_SENDING_TYPE)
export type SmsTemplateSendingType = z.infer<typeof SmsTemplateSendingTypeSchema>

export const SmsTemplateSchema = z.object({
  id: z.number(),
  academyId: AcademySchema.shape.academyId,
  type: SmsTemplateTypeSchema,
  templateSendingType: SmsTemplateSendingTypeSchema.nullable(),
  title: z.string(),
  content: z.string(),
})
export type SmsTemplate = z.infer<typeof SmsTemplateSchema>

/** 템플릿에 학생·조건을 채워 만든 발송 미리보기 */
export const SmsTemplateSampleSchema = z.object({
  templateId: SmsTemplateSchema.shape.id,
  messages: z.string(),
})
export type SmsTemplateSample = z.infer<typeof SmsTemplateSampleSchema>
